<template lang="pug">
  div.wrap-drawer-menu
    transition(name="overlay")
      div(v-if="show" @click="$emit('close')").overlay.cursor-pointer
    transition(name="menu")
      div(v-if="show").wrap-menu
        div(v-if="user" @click="$router.push(`/profile/${user.uid}`)").wrap-user.mt32.mb32
          div.f.fc.mb12
            v-avatar(size="120")
              v-img(:src="user.iconPhotoURL")
          span.block.text-center {{user.displayName}}
        div.wrap-list
          div(v-for="item in menu"
            @click="$router.push(item.to)").list.f.fm.flex-between.px2.pb3.mb6
            div.f.fm
              v-icon.mr8(:color="item.color") {{item.icon}}
              span.pt2(:style="{color:item.color}") {{item.label}}
            v-icon mdi-chevron-right
</template>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.wrap-drawer-menu {
  .overlay {
    position: fixed;
    z-index: 2000;
    left: 0; top: 0;
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
  .wrap-menu {
    position: fixed;
    z-index: 2001;
    left: 0; top: 0;
    width: 240px; height: 100%;
    background: $primary_bg_color;
    .wrap-list {
      width: 90%;
      margin: 0 auto;
      .list {
        border-bottom: solid $border_size $border_color;
      }
    }
  }
}

.overlay-leave-active, .overlay-enter-active {
  transition: opacity 0.4s $ease_out_expo;
}
.overlay-enter, .overlay-leave-to {
  opacity: 0;
}
.overlay-enter-to, .overlay-leave {
  opacity: 1;
}

.menu-leave-active, .menu-enter-active {
  transition: all 0.4s $ease_out_expo;
}
.menu-enter, .menu-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.menu-enter-to, .menu-leave {
  transform: translateX(0%);
  opacity: 1;
}
</style>

<script>
import database from '@/database'

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    uid: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      user: null,
      menu: []
    }
  },
  async created () {
    this.user = await database.userCollection().findById(this.uid)
    this.menu = [
      { label: 'ライセンス', to: `/license/${this.user.uid}`, icon: 'mdi-certificate-outline', color: 'default' },
      { label: 'プロフィール', to: `/profile/${this.user.uid}`, icon: 'mdi-account', color: 'default' },
      { label: '設定', to: '/settings', icon: 'mdi-cogs', color: 'default' }
    ]
  }
}
</script>
